import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { BsPencil } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import orgApi from "../../../api/org_api";
import PaginationButtons from "../../../component/PaginationButtons";
import { Breadcrumb, SearchInput } from "../../../component/common";
const nodata = require("../../../assets/images/nodata.png");

type JdListProps = { setLoading: Function };

const JdList: React.FC<JdListProps> = ({ setLoading }: JdListProps) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const resumeData = state?.resumes || [];
  const resumeType = state?.resumeType || [];
  // const [view, setView] = React.useState<string>("grid");
  const [totalPages, setTotalPages] = React.useState(
    Number(localStorage.getItem("jd_totalpage")!),
  );
  const [pages, setPages] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    Number(localStorage.getItem("jd_currentpage")!),
  );

  React.useEffect(() => {
    setCurrentPage(Number(localStorage.getItem("jd_currentpage")!));
  }, []);

  const [selectedJd, setSelectedJd] = React.useState("");
  const [showResumeUpload, setShowResumeUpload] = React.useState(false);
  const [totalPost, setTotal] = React.useState(1);
  const [isDisabled, setisDisabled] = React.useState(false);
  const [roundTag, setRoundTag] = React.useState("external");
  const [search, setSearch] = React.useState("");
  const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
  const orgId = org.id;
  const masterId = org.master_id !== null ? org.master_id : org.id;

  React.useEffect(() => {
    fetchData();
  }, [currentPage]);

  React.useEffect(() => {
    if (search.length >= 0) {
      fetchData();
    }
  }, [search]);

  const fetchData = async () => {
    const page = totalPages === 0 ? 1 : Math.min(currentPage + 1, totalPages);
    localStorage.setItem("jd_currentpage", currentPage.toString());
    setLoading(true);
    const reqData = { search: search, page: page, take: 10 };
    const res = await orgApi.getJdList(org.id, reqData);
    if (res.data.success) {
      setTotal(res.data.total_post);
      var t = Math.ceil(res.data.total_post / 10);
      setTotalPages(t);
      localStorage.setItem("jd_totalpage", t.toString());
      setPages(res.data.post);
    } else {
      setPages([]);
      setTotal(0);
    }
    setLoading(false);
  };

  const getDate = (dateStr: string) => {
    const formattedDate = convert(dateStr!);
    return formattedDate;
  };
  function convert(str: string) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const gotoUploadCandidate = (id: any) => navigate("/upload_candidate/" + id);
  const openResumeUpload = (id: any) => {
    setSelectedJd(id);
    setShowResumeUpload(true);
  };
  const setRoundData = async (post_id: any) => {
    let roundTag1 = "";
    setLoading(true);
    const res = await orgApi.getRound(post_id);
    if (res.data.success) {
      let roundData = res.data.round;
      if (roundData != null) {
        let d = roundData;
        if (
          d["fav"] ||
          (d["house"] && d["market"] && !d["external"]) ||
          (!d["house"] && d["market"] && d["external"]) ||
          (d["house"] && d["market"] && d["external"])
        ) {
          roundTag1 = "combination";
        } else if (!d["house"] && d["market"] && !d["external"]) {
          roundTag1 = "external";
        } else if (
          (d["house"] && !d["market"] && !d["external"]) ||
          (!d["house"] && !d["market"] && d["external"]) ||
          (d["house"] && !d["market"] && d["external"])
        ) {
          roundTag1 = "internal";
        }
        setRoundTag(roundTag1);
      }
    }
    setLoading(false);
    return roundTag1;
  };
  const getSubscription = async (resLen: any, post_id: any) => {
    let roundTag1 = await setRoundData(post_id);
    setLoading(true);
    let userInfo = JSON.parse(
      localStorage.getItem("user__details")?.toString()!,
    );
    let orgId = userInfo.master_id !== null ? userInfo.master_id : userInfo.id;
    const res = await orgApi.getSubs(orgId);
    if (res.data.success) {
      setLoading(false);
      let subscription = res.data.org;
      if (roundTag1 === "external" && subscription.e_available < resLen) {
        toast(
          `You can upload a maximum of ${subscription.e_available} resumes.`,
        );
        return false;
      } else if (
        roundTag1 === "internal" &&
        subscription.i_available < resLen
      ) {
        toast(
          `You can upload a maximum of ${subscription.i_available} resumes.`,
        );
        return false;
      } else if (roundTag1 === "combination") {
        let min =
          subscription.i_available >= subscription.e_available
            ? subscription.e_available
            : subscription.i_available;
        if (min < resLen) {
          toast(`You can upload a maximum of ${min} resumes.`);
          return false;
        }
      }
    } else {
      setLoading(false);
      return true;
    }
    return true;
  };
  const uploadResume = async () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let mv: Boolean | undefined = await getSubscription(
      resumeData.length,
      selectedJd,
    );
    if (!mv) {
      return;
    }
    let scope = [] as any;
    resumeType.forEach((r_type: any) => {
      scope.push({ type: r_type ? "sit" : "others" });
    });
    const formData = new FormData();
    formData.append("org_id", orgId);
    formData.append("tz", timezone);
    formData.append("master_id", masterId);
    formData.append("tag", roundTag);
    formData.append("scope", JSON.stringify(scope));
    for (let k = 0; k < resumeData.length; k++) {
      formData.append("resume", resumeData[k]);
    }
    setLoading(true);
    setisDisabled(true);
    const res = await orgApi.uploadCandidate(formData, selectedJd);
    if (res.data.success === true) {
      toast(res.data.msg);
      setShowResumeUpload(false);
      navigate("/upload_candidate/" + selectedJd, { replace: true });
    } else {
      toast(res.data.msg);
    }
    setisDisabled(false);
    setLoading(false);
  };

  return (
    <>
      {showResumeUpload && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="fixed inset-0 w-full h-full bg-black opacity-50"></div>
          <div className="flex items-center min-h-screen px-4 py-8">
            <div className="relative w-full max-w-lg p-4 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl">
              <div className="sm:flex">
                <div className="mt-1 text-center sm:text-left w-full">
                  <div className="flex items-center justify-between border-b">
                    <h6 className="text-sm font-bold text-gray-800 mb-2">
                      Upload candidate
                    </h6>
                  </div>
                  <div className=" w-full mt-4 max-w-lg text-xs text-gray-500 font-normal">
                    Are you sure you want to upload the selected candidates to
                    this JD
                  </div>
                  <div className=" gap-2 mt-3 sm:flex md:flex lg:flex flex-row-reverse">
                    <button
                      className={
                        !isDisabled
                          ? "mt-2 py-1 px-2.5 text-white button-primary outline-none text-sm rounded-md"
                          : "mt-2 py-1 px-2.5 text-white button-primary-tint outline-none text-sm rounded-md"
                      }
                      onClick={() => uploadResume()}
                      disabled={isDisabled}
                    >
                      Confirm
                    </button>
                    <button
                      className=" mt-2 py-1 px-2.5 text-gray-800 outline-none border text-sm rounded-md"
                      onClick={() => setShowResumeUpload(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className=" flex flex-col space-y-3 2xl:h-[calc(100vh-105px)]   h-[calc(100vh-90px)]">
        <div className="flex flex-wrap gap-2 justify-between items-center">
          <Breadcrumb
            items={[
              {
                text: "Dashboard",
                href: "/dashboard",
              },
              {
                text: "Job Description (" + totalPost + ")",
                isActive: true,
              },
            ]}
          />
          <div className="flex gap-4 justify-between items-center">
            <SearchInput
              placeholder="Search.."
              value={search}
              onChange={(e) => setSearch(e)}
              onCancel={() => setSearch("")}
            />
            {/* <div className="flex flex-row justify-end items-center">
              <button
                type="button"
                className={cn(
                  view === "grid"
                    ? " py-1.5 px-3.5 text-primary outline-none border-primary text-xs rounded-l-md"
                    : "py-1.5 px-3.5 text-gray-300 outline-none border text-xs rounded-l-md",
                )}
                onClick={() => setView("grid")}
              >
                <BsFillGridFill size={20} />
              </button>
              <button
                type="button"
                className={
                  view === "list"
                    ? " py-1.5 px-3.5 text-primary outline-none border-primary text-xs rounded-r-md"
                    : " py-1.5 px-3.5 text-gray-300 outline-none border text-xs rounded-r-md"
                }
                onClick={() => setView("list")}
              >
                <BsFillHddStackFill size={20} />
              </button>
            </div> */}
          </div>
        </div>

        <div className="overflow-y-auto">
          <div className="h-[calc(100vh-165px)] 2xl:h-[calc(100vh-200px)] ">
            {totalPost === 0 && (
              <div className="flex flex-col justify-center items-center my-16 gap-1">
                <img
                  src={nodata}
                  alt="user_profile_photo"
                  className="h-32 w-32 object-cover"
                ></img>
                <p className="text-xs font-thin text-gray-400">
                  No JD Created.
                </p>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
              {pages.map((e: any) => (
                <div
                  key={e.id}
                  className="bg-blue-50/30 rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-md transition-all duration-200 cursor-pointer"
                  onClick={() => {
                    if (e.profile === 0) {
                      navigate("/upload_jd", { state: { postId: e.id } });
                    } else {
                      if (resumeData.length === 0) {
                        gotoUploadCandidate(e.id);
                      } else {
                        openResumeUpload(e.id);
                      }
                    }
                  }}
                >
                  <div className="p-3 border-b border-gray-100">
                    <div className="flex justify-between items-start">
                      <div className="flex-1 min-w-0">
                        <p className="text-md font-semibold text-gray-900 truncate mb-2">
                          {e.job_title}
                        </p>
                        <div className="flex items-center gap-2">
                          <span className="text-xs border bg-blue-50 text-blue-700 border-blue-200 px-2 py-1 rounded-lg">
                            ID: {e.unique_id}
                          </span>
                          {e.location && (
                            <span className="text-xs border bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200 px-2 py-1 rounded-lg">
                              {e.location}
                            </span>
                          )}
                          {e.profile === 0 && (
                            <span className="text-xs border border-amber-200 bg-amber-50  text-amber-600 px-2 py-1 rounded-lg">
                              Draft
                            </span>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          navigate("/upload_jd", { state: { postId: e.id } });
                        }}
                        className="text-gray-400 hover:text-blue-600 hover:bg-blue-50 p-2 rounded-lg transition-colors"
                      >
                        <BsPencil size={14} />
                      </button>
                    </div>
                  </div>

                  <div className="p-3">
                    <div className="space-y-3">
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Profiles</span>
                        <span className="text-lg font-bold text-blue-600">
                          {e.profile}
                        </span>
                      </div>

                      <div className="flex justify-between items-center  border-gray-100">
                        <span className="text-sm text-gray-600">
                          Valid Upto
                        </span>
                        <span className="text-sm font-medium text-gray-700">
                          {getDate(e.post_validity)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* {view === "grid" && (
              
             )} */}
            {/* {view === "list" && (
              <div className="bg-white  overflow-y-auto rounded-lg border border-gray-200 shadow-sm">
                <div className="grid grid-cols-12 gap-4 px-6 py-3 bg-blue-600 border-b border-gray-200 text-xs font-semibold text-white uppercase tracking-wider">
                  <div className="col-span-4">Job Details</div>
                  <div className="col-span-2 text-center">Profiles</div>
                  <div className="col-span-4 text-center">Progress</div>
                  <div className="col-span-2 text-right">Status</div>
                </div>
                <div className="divide-y divide-gray-100">
                  {pages.map((e: any) => (
                    <div
                      key={e.id}
                      className="grid grid-cols-12 gap-4 px-6 py-4 hover:bg-blue-50 transition-colors duration-150 cursor-pointer group"
                      onClick={() => {
                        if (e.profile === 0) {
                          navigate("/upload_jd", { state: { postId: e.id } });
                        } else {
                          if (resumeData.length === 0) {
                            gotoUploadCandidate(e.id);
                          } else {
                            openResumeUpload(e.id);
                          }
                        }
                      }}
                    >
                      <div className="col-span-4 flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                          <h6 className="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                            {e.job_title}
                          </h6>
                          <button
                            type="button"
                            className="opacity-0 group-hover:opacity-100 p-1 text-gray-400 hover:text-blue-600 hover:bg-blue-100 rounded transition-all duration-200"
                            onClick={(event: any) => {
                              event.stopPropagation();
                              navigate("/upload_jd", {
                                state: { postId: e.id },
                              });
                            }}
                          >
                            <BsPencil className="w-3 h-3" />
                          </button>
                        </div>
                        <div className="flex items-center gap-4 text-xs text-gray-500">
                          <span className="flex items-center gap-1">
                            <span className="font-medium">ID:</span>
                            {e.unique_id}
                          </span>
                          <span className="flex items-center gap-1">
                            <span className="font-medium">Date:</span>
                            {getDate(e.post_validity)}
                          </span>
                        </div>
                      </div>

                      <div className="col-span-2 flex flex-col items-center justify-center">
                        <div className="text-lg font-bold text-gray-900">
                          {e.profile}
                        </div>
                        <div className="text-xs text-gray-400 mt-1">
                          Candidates
                        </div>
                      </div>

                      <div className="col-span-4 flex items-center">
                        {e.profile !== 0 ? (
                          <div className="w-full">
                            <div className="flex justify-between items-center mb-1">
                              <span className="text-xs text-gray-600">
                                Progress
                              </span>
                              <span className="text-xs font-medium text-gray-900">
                                {e.offered}/{e.no_of_candidate}
                              </span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                style={{
                                  width: `${(e.offered / e.no_of_candidate) * 100}%`,
                                }}
                              ></div>
                            </div>
                          </div>
                        ) : (
                        <div className="text-center w-full text-gray-400 text-sm">
                          No progress data
                        </div>
                        )}
                      </div>

                      <div className="col-span-2 flex items-center justify-end">
                        {e.profile === 0 ? (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                            Draft
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            Active
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )} */}
          </div>
        </div>

        {totalPost > 10 && (
          <PaginationButtons
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </>
  );
};
export default JdList;
